// Params that change within the BLE without leaving it. Allowlisted (not blocklisted)
// so a future overlay param defaults to "exit" rather than silently bypassing the gate.
const BLE_IN_MODE_PARAMS = new Set(["tool", "zoom", "levels", "view", "background", "topOfChart"]);

export const isBoxLayoutOverlayExit = (currentSearch: string, nextSearch: string): boolean => {
  const cur = new URLSearchParams(currentSearch);
  const next = new URLSearchParams(nextSearch);
  const keys = new Set([...cur.keys(), ...next.keys()]);
  for (const key of keys) {
    if (cur.get(key) === next.get(key)) continue;
    if (!BLE_IN_MODE_PARAMS.has(key)) return true;
  }
  return false;
};

// The surface-opening params the user added (e.g. {display:"directory"}). Carried
// onto the chart route so the surface opens there instead of over a torn-down BLE.
export const getOverlayExitParams = (
  currentSearch: string,
  nextSearch: string
): Record<string, string> => {
  const cur = new URLSearchParams(currentSearch);
  const next = new URLSearchParams(nextSearch);
  const params: Record<string, string> = {};
  for (const [key, value] of next.entries()) {
    if (BLE_IN_MODE_PARAMS.has(key)) continue;
    if (cur.get(key) === value) continue;
    params[key] = value;
  }
  return params;
};
